module.exports = __webpack_public_path__ + "img/draw-pointer.73ba8c41.png";